import { createRoutine } from 'redux-saga-routines';

export const fetchPosLocationOptions = createRoutine(
  'FETCH_POS_LOCATION_OPTIONS'
);
